export enum CargoHandlingCondition {
	LOAD_HANDLED_WITH_BOTH_HANDS = 'load_handled_with_both_hands',
	LOAD_HANDLED_WITH_TEMPORARILY_ONE_HAND = 'load_handled_with_temporarily_one_hand',
	LOAD_HANDLED_WITH_ONE_HAND = 'load_handled_with_one_hand'
}

export enum BodyPosture {
	OPTION_1 = 'option_1',
	OPTION_2 = 'option_2',
	OPTION_3 = 'option_3',
	OPTION_4 = 'option_4',
	OPTION_5 = 'option_5',
	OPTION_6 = 'option_6',
	OPTION_7 = 'option_7',
	OPTION_8 = 'option_8',
	OPTION_9 = 'option_9',
	OPTION_10 = 'option_10'
}

export enum PostureTwist {
	TWIST_OCCASIONAL_TRUNK = 'twist_occasional_trunk',
	TWIST_FREQUENT_TRUNK = 'twist_frequent_trunk'
}

export enum PostureLoadCenter {
	LOAD_CENTER_OCCASIONAL = 'load_center_occasional',
	LOAD_CENTER_FREQUENT = 'load_center_frequent'
}

export enum PostureArms {
	ARMS_OCCASIONAL = 'arms_occasional',
	ARMS_FREQUENT = 'arms_frequent'
}

export enum PostureHands {
	HANDS_OCCASIONAL = 'hands_occasional',
	HANDS_FREQUENT = 'hands_frequent'
}

export enum WorkConditionHandsPosition {
	HANDS_POSITION_OCCASIONAL = 'hands_position_occasional',
	HANDS_POSITION_FREQUENT = 'hands_position_frequent'
}

export enum WorkConditionTransfer {
	TRANSFER_OCCASIONAL = 'transfer_occasional',
	TRANSFER_FREQUENT = 'transfer_frequent'
}

export enum WorkConditionSpatialCondition {
	SPATIAL_CONDITION_RESTRICTED = 'spatial_condition_occasional',
	SPATIAL_CONDITION_UNFAVOURABLE = 'spatial_condition_frequent'
}

export enum WorkConditionAdverse {
	CLIMATICAL_CONDITIONS_UNFAVOURABLE = 'climatical_conditions_unfavourable'
}

export enum WorkConditionClothes {
	CLOTHES_ADDITIONAL_EFFORT = 'clothes_additional_effort'
}

export enum WorkConditionHoldLoad {
	HOLD_LOAD_DIFFICULT = 'hold_load_difficult',
	HOLD_LOAD_SIGNIFICANT_DIFFICULTY = 'hold_load_significant_difficulty'
}

export enum WorkOrganization {
	GOOD = 'good',
	RESTRICTED = 'restricted',
	DESFAVORED = 'desfavored'
}

export enum RiskLevel {
	LOW = 'LOW',
	SLIGHTLY_INCREASED = 'SLIGHTLY_INCREASED',
	SUBSTANTIALLY_INCREASED = 'SUBSTANTIALLY_INCREASED',
	HIGH = 'HIGH'
}
